import { mainHeaderTurtle } from "../../../static/svgs/mainHeader"

export enum MainHeaders {
  Attributions,
  Description,
  Contribution,
  Engineering,
  Collaborations,
  HumanPractices,
  Implementation,
  PartCollection,
  Model,
  ProofOfConcept,
  Partnership,
  Communication,
  Education,
  Hardware,
  Measurement,
  Safety,
  Software,
  Sustainable,
  Design,
  Experiments,
  Results,
  Team,
}

export const MainHeadersData = [
  {
    pageName: "Attributions",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Description",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Contribution",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Engineering",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Collaborations",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Human practices",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Implementation",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Part Collection",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Model",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Proof of Concept",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Partnership",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Communication",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Education",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Hardware",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Measurement",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Safety",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Software",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Sustainability",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Design",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Experiments",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Results",
    turtle: mainHeaderTurtle,
  },
  {
    pageName: "Team",
    turtle: mainHeaderTurtle,
  },
]
